import React from 'react';
import { motion } from 'framer-motion';
import { Smartphone } from 'lucide-react';

const ProjectDetailHero = () => {
  return (
    <section className="pt-40 pb-20">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="flex items-center gap-2 text-accent mb-6"
          >
            <Smartphone className="w-5 h-5" />
            <span>Mobile App</span>
          </motion.div>
          
          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.1 }}
            className="text-4xl md:text-5xl lg:text-6xl font-display font-semibold text-white mb-6 leading-[1.2]"
          >
            Expo City Dubai Mobile App
          </motion.h1>

          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="text-xl text-gray-300 leading-relaxed"
          >
            Experience the future of urban living through an intuitive mobile companion that transforms 
            how visitors and residents interact with Expo City Dubai.
          </motion.p>
        </div>
      </div>
    </section>
  );
};

export default ProjectDetailHero;